import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
// import { finalize, map } from "rxjs/operators";
import { LoaderService } from "src/app/shared/service/loader.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(public loaderService: LoaderService) {}
  //     intercept(
  //       req: HttpRequest<any>,
  //       next: HttpHandler
  //     ): Observable<HttpEvent<any>> {
  //     //   this.loaderService.show();
  //     this.loaderService.isLoading$.next(true);

  //       console.log("intercept--->" + req);
  //       return next.handle(req).pipe(
  //         finalize(() => {
  //         //   this.loaderService.hide();
  //         this.loaderService.isLoading$.next(false);
  //           console.log("finalize--->" + req);
  //         })
  //       );

  //     //   return next.handle(req).pipe(map(event => {
  //     //       if (event instanceof HttpResponse) {
  //     //         this.loaderService.isLoading$.next(false);
  //     //       }
  //     //       return event;
  //     //   }));
  //     }
  //   }
  private requests: HttpRequest<any>[] = [];

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading$.next(this.requests.length > 0);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.requests.push(req);
    // console.log("No of requests--->" + this.requests.length);

    this.loaderService.isLoading$.next(true);
    return new Observable((observer) => {
      const subscription = next.handle(req).subscribe(
        (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
            // console.log("event--->" + event);
          }
        },
        (err) => {
          //   alert('error: ' + err);
          this.removeRequest(req);
          observer.error(err);
          //   console.log("err--->" + err);
        },
        () => {
          this.removeRequest(req);
          observer.complete();
          //   console.log("complete--->" + req);
        }
      );
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        // console.log("return--->" + req);
        subscription.unsubscribe();
      };
    });
  }
}
